// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"189":"aa5ea0be","872":"aa5ea0be"}[chunkId] + ".css";
};